import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { bookingShape } from 'constants/propTypes';

import Modal from 'components/ui/Modal';
import { ActionButton } from 'components/ui/Button';

import useVoidBooking from './useVoidBooking';

const VoidBookingCta = ({ bookingReference, booking, disabled }) => {
  const { isConfirmOpen, isErrorOpen, errorMessageId, isLoading, isConfirming, handleClick, handleConfirm, closeConfirm, closeError } =
    useVoidBooking({ bookingReference, booking });

  return (
    <>
      <ActionButton disabled={disabled || isLoading} loading={isLoading} data-cy="void-booking" onClick={handleClick}>
        <FormattedMessage id="voidBooking.button" />
      </ActionButton>

      <Modal
        isOpen={isConfirmOpen}
        onClose={closeConfirm}
        title={<FormattedMessage id="voidBooking.title" />}
        bottomRow={
          <>
            <ActionButton onClick={handleConfirm} loading={isConfirming} disabled={isConfirming}>
              <FormattedMessage id="voidBooking.confirm" />
            </ActionButton>
            <ActionButton onClick={closeConfirm} disabled={isConfirming}>
              <FormattedMessage id="voidBooking.abandon" />
            </ActionButton>
          </>
        }
      >
        <p>
          <FormattedMessage id="voidBooking.warning" />
        </p>
        <p>
          <FormattedMessage id="voidBooking.refundMsg" />
        </p>
      </Modal>

      <Modal
        isOpen={isErrorOpen}
        onClose={closeError}
        title={<FormattedMessage id="voidBooking.title" />}
        bottomRow={
          <ActionButton onClick={closeError}>
            <FormattedMessage id="voidBooking.abandon" />
          </ActionButton>
        }
      >
        {errorMessageId && (
          <p>
            <FormattedMessage id={errorMessageId} />
          </p>
        )}
      </Modal>
    </>
  );
};

VoidBookingCta.propTypes = {
  bookingReference: PropTypes.string.isRequired,
  booking: bookingShape.isRequired,
  disabled: PropTypes.bool
};

export default VoidBookingCta;
